export const ValueFormatter = (value, format) => {

    // 값이 없는 경우
    if ([undefined, null, NaN].includes(value)) {
        return '-'
    }
  
    switch (format) {
      case 'currency':
        return value.toLocaleString()
      case 'percent':
        return value + '%'
      default:
        return value;
    }
    
};